var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./keyFigures.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4d666c6b\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./keyFigures.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/opt/build/repo/src/pages/economy/learning/keyFigures.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] keyFigures.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d666c6b", Component.options)
  } else {
    hotAPI.reload("data-v-4d666c6b", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/economy/learning/keyFigures.vue
// module id = 714
// module chunks = 0